import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/workspace/src/components/layout/Providers.tsx");
